(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/video-player-loader.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/video-player-loader.js'); 
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var helper = isServer ? require(require('path').join(__dirname, 'helpers', 'server.js')) : svs.components.emp_video_player.helpers.client;

var setDefaultOptions = function setDefaultOptions(options) {
  options.customer = options.customer || 'SvenskaSpel';
  options.businessUnit = options.businessUnit || 'VOD';
  options.autoplay = typeof options.autoplay === 'boolean' ? options.autoplay : true;
  options.autoplay = options.autoplay ? 'any' : false;
  options.width = options.width || 800;
  return options;
};

var setEvents = function setEvents(player, node) {
  player.on('ready', function () {
    node.querySelector('.js-emp-spinner').style.display = 'none';
  });
};


var loadVideo = function loadVideo(node, options) {
  options = setDefaultOptions(options);
  svs.core.module.load('/cl/libs/empplayer2', function (error) {
    if (error) {
      helper.vars.logger.err('failed to load empplayer2 component');
    } else {
      helper.vars.logger.log('loaded empplayer2 component');
    }
  }, function () {
    var loader = new svs.components.Loader($(node.querySelector('.js-emp-spinner')));
    loader.show();
    node.querySelector('.emp-thumbnail').style.display = 'none';
    var empPlayerOptions = {
      controls: true,
      ericssonexposure: {
        businessUnit: options.businessUnit,
        customer: options.customer,
        exposureApiURL: helper.vars.redBeeHost
      }
    };
    var exposure = empPlayer.getExposure(empPlayerOptions.ericssonexposure);
    var player;
    exposure.login('', '', function (response) {
      if (response.success) {
        empPlayerOptions.ericssonexposure.sessionToken = response.session.sessionToken;
        player = empPlayer(node.querySelector('video'), empPlayerOptions, function () {
          setEvents(player, node);
          player.startPlaybackV2(options.assetId, {
            autoplay: options.autoplay
          });
        });
      } else {
        helper.vars.logger.warn('empplayer2 login failed', response);
      }
    });
  }, false, true);
};

var loadLibrary = function loadLibrary() {
  svs.core.module.load('/cl/libs/empplayer2', function (error) {
    if (error) {
      helper.vars.logger.err('failed to load empplayer2 component');
    } else {
      helper.vars.logger.log('loaded empplayer2 component');
    }
  }, function () {
    var loader = new svs.components.Loader('.js-emp-video .emp-spinner');
    loader.show();
  });
};


var getMeta = function getMeta(options) {
  if (!options) {
    helper.vars.logger.warn('No option parameter.');
    return;
  }

  options = setDefaultOptions(options);
  var requestUri = "".concat(helper.vars.redBeeHost, "/v1/customer/").concat(options.customer) + "/businessunit/".concat(options.businessUnit, "/content/asset/").concat(options.assetId) + "?fieldSet=ALL&onlyPublished=true&includeUserData=false";
  return helper.getMeta({
    options: options,
    requestUri: requestUri
  });
};

if (isServer) {
  module.exports = {
    getMeta: getMeta
  };
} else {
  svs.components.emp_video_player.contentLoader = {
    getMeta: getMeta,
    loadLibrary: loadLibrary,
    loadVideo: loadVideo
  };
}
 })(window);